var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 240.8",
    style: {
      enableBackground: "new 0 0 800 240.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A6A6A6;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:1.1852;stroke-miterlimit:59.2593;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:url(#SVGID_00000080205028655277943540000011623597708691214781_);}\n\t.st5{fill:url(#SVGID_00000079450662443024863960000000395601320638273450_);}\n\t.st6{fill:url(#SVGID_00000127041075664044189960000009805122994383431093_);}\n\t.st7{opacity:0.2;enable-background:new    ;}\n\t.st8{opacity:0.12;enable-background:new    ;}\n\t.st9{opacity:0.25;fill:#FFFFFF;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M770.4,239.6H29.6C13,239.6,0,226.5,0,209.9V32.2C0,15.6,13,2.5,29.6,2.5h740.7c16.6,0,29.6,13,29.6,29.6v177.8 C800,226.5,787,239.6,770.4,239.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M770.4,7.3c13.6,0,24.9,11.3,24.9,24.9v177.8c0,13.6-11.3,24.9-24.9,24.9H29.6c-13.6,0-24.9-11.3-24.9-24.9 V32.2C4.7,18.5,16,7.3,29.6,7.3H770.4 M770.4,2.5H29.6C13,2.5,0,16.2,0,32.2v177.8c0,16.6,13,29.6,29.6,29.6h740.7 c16.6,0,29.6-13,29.6-29.6V32.2C800,16.2,787,2.5,770.4,2.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M280.9,63c0,4.7-1.2,8.9-4.1,11.9c-3.6,3.6-7.7,5.3-13,5.3s-9.5-1.8-13-5.3c-3.6-3.6-5.3-7.7-5.3-13 c0-5.3,1.8-9.5,5.3-13c3.6-3.6,7.7-5.3,13-5.3c2.4,0,4.7,0.6,7.1,1.8c2.4,1.2,4.1,2.4,5.3,4.1l-3,3c-2.4-3-5.3-4.1-9.5-4.1 c-3.6,0-7.1,1.2-9.5,4.1c-3,2.4-4.1,5.9-4.1,10.1s1.2,7.7,4.1,10.1s5.9,4.1,9.5,4.1c4.1,0,7.1-1.2,10.1-4.1c1.8-1.8,3-4.1,3-7.1h-13 v-4.7h17.2L280.9,63L280.9,63z M308.1,48.2h-16v11.3H307v4.1h-14.8v11.3h16v4.7h-20.7V44h20.7V48.2z M327.7,79.6H323V48.2h-10.1V44 h24.9v4.1h-10.1V79.6z M355,79.6V44h4.7v35.6H355z M379.9,79.6h-4.7V48.2H365V44h24.3v4.1h-10.1v31.4H379.9z M436.1,74.8 c-3.6,3.6-7.7,5.3-13,5.3c-5.3,0-9.5-1.8-13-5.3c-3.6-3.6-5.3-7.7-5.3-13c0-5.3,1.8-9.5,5.3-13c3.6-3.6,7.7-5.3,13-5.3 c5.3,0,9.5,1.8,13,5.3s5.3,7.7,5.3,13C441.5,67.1,439.7,71.3,436.1,74.8z M413.6,71.9c2.4,2.4,5.9,4.1,9.5,4.1s7.1-1.2,9.5-4.1 c2.4-2.4,4.1-5.9,4.1-10.1s-1.2-7.7-4.1-10.1c-2.4-2.4-5.9-4.1-9.5-4.1s-7.1,1.2-9.5,4.1c-2.4,2.4-4.1,5.9-4.1,10.1 S410.7,69.5,413.6,71.9z M448,79.6V44h5.3l17.2,27.9V44h4.7v35.6h-4.7l-18.4-29v29H448L448,79.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M403.6,131.7c-14.2,0-25.5,10.7-25.5,25.5c0,14.2,11.3,25.5,25.5,25.5S429,172,429,157.2 C429,141.8,417.8,131.7,403.6,131.7z M403.6,172c-7.7,0-14.2-6.5-14.2-15.4c0-8.9,6.5-15.4,14.2-15.4c7.7,0,14.2,5.9,14.2,15.4 C417.8,165.5,411.3,172,403.6,172z M348.4,131.7c-14.2,0-25.5,10.7-25.5,25.5c0,14.2,11.3,25.5,25.5,25.5s25.5-10.7,25.5-25.5 C373.9,141.8,362.7,131.7,348.4,131.7z M348.4,172c-7.7,0-14.2-6.5-14.2-15.4c0-8.9,6.5-15.4,14.2-15.4c7.7,0,14.2,5.9,14.2,15.4 C362.7,165.5,356.1,172,348.4,172z M282.7,139.4v10.7h25.5c-0.6,5.9-3,10.7-5.9,13.6c-3.6,3.6-9.5,7.7-19.6,7.7 c-16,0-27.9-12.4-27.9-28.4s12.4-28.4,27.9-28.4c8.3,0,14.8,3.6,19.6,7.7l7.7-7.7c-6.5-5.9-14.8-10.7-26.7-10.7 c-21.3,0-39.7,17.8-39.7,39.1s18.4,39.1,39.7,39.1c11.9,0,20.1-3.6,27.3-11.3c7.1-7.1,9.5-17.2,9.5-24.9c0-2.4,0-4.7-0.6-6.5 L282.7,139.4L282.7,139.4z M551.7,147.7c-2.4-5.9-8.3-16-21.3-16c-13,0-23.7,10.1-23.7,25.5c0,14.2,10.7,25.5,24.9,25.5 c11.3,0,18.4-7.1,20.7-11.3l-8.3-5.9c-3,4.1-6.5,7.1-12.4,7.1c-5.9,0-9.5-2.4-12.4-7.7l33.8-14.2L551.7,147.7L551.7,147.7z  M517.3,156c0-9.5,7.7-14.8,13-14.8c4.1,0,8.3,2.4,9.5,5.3L517.3,156L517.3,156z M489.5,180.3h11.3v-74.1h-11.3V180.3z M471.7,137 c-3-3-7.7-5.9-13.6-5.9c-12.4,0-24.3,11.3-24.3,25.5s11.3,24.9,24.3,24.9c5.9,0,10.7-3,13-5.9h0.6v3.6c0,9.5-5.3,14.8-13.6,14.8 c-6.5,0-11.3-4.7-12.4-8.9l-9.5,4.1c3,6.5,10.1,14.8,22.5,14.8c13,0,23.7-7.7,23.7-26.1v-45h-10.7L471.7,137L471.7,137z M458.7,172 c-7.7,0-14.2-6.5-14.2-15.4s6.5-15.4,14.2-15.4c7.7,0,13.6,6.5,13.6,15.4S466.4,172,458.7,172z M603.3,106.2h-26.7v74.1h11.3v-27.9 h15.4c12.4,0,24.3-8.9,24.3-23.1C627.6,115.1,615.7,106.2,603.3,106.2z M603.9,141.8h-16v-25.5h16c8.3,0,13,7.1,13,12.4 C616.3,135.3,611.6,141.8,603.9,141.8L603.9,141.8z M672,131.1c-8.3,0-16.6,3.6-19.6,11.3l10.1,4.1c2.4-4.1,5.9-5.3,10.1-5.3 c5.9,0,11.3,3.6,11.9,9.5v0.6c-1.8-1.2-6.5-3-11.3-3c-10.7,0-21.3,5.9-21.3,16.6c0,10.1,8.9,16.6,18.4,16.6c7.7,0,11.3-3.6,14.2-7.1 h0.6v5.9h10.7v-28.4C694.5,138.8,684.4,131.1,672,131.1L672,131.1z M670.8,172c-3.6,0-8.9-1.8-8.9-6.5c0-5.9,6.5-7.7,11.9-7.7 c4.7,0,7.1,1.2,10.1,2.4C682.7,167.3,676.7,172,670.8,172z M733,132.9l-12.4,32H720l-13-32h-11.9l19.6,45l-11.3,24.9h11.3l30.2-69.9 H733L733,132.9z M633.5,180.3h11.3v-74.1h-11.3V180.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -212.6172,
    y1: 477.0605,
    x2: -229.4002,
    y2: 493.8425,
    gradientTransform: "matrix(5.9259 0 0 5.9259 1389.1111 -2772.9167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007000001,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61.6,47c-1.8,1.8-2.4,4.7-2.4,8.3v131c0,3.6,1.2,6.5,3,8.3l0.6,0.6l73.5-73.5v-1.2L61.6,47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086670619552951110930000013157667105363834778_",
    gradientUnits: "userSpaceOnUse",
    x1: -200.5785,
    y1: 488.4052,
    x2: -224.7755,
    y2: 488.4052,
    gradientTransform: "matrix(5.9259 0 0 5.9259 1389.1111 -2772.9167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086670619552951110930000013157667105363834778_)"
    },
    d: "M160,146.5l-24.3-24.3v-1.8L160,96.2 l0.6,0.6l29,16.6c8.3,4.7,8.3,12.4,0,17.2L160,146.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087382927186331314290000012613685449272360610_",
    gradientUnits: "userSpaceOnUse",
    x1: -209.597,
    y1: 490.6396,
    x2: -232.355,
    y2: 513.3976,
    gradientTransform: "matrix(5.9259 0 0 5.9259 1389.1111 -2772.9167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087382927186331314290000012613685449272360610_)"
    },
    d: "M160.6,145.9L135.7,121l-74.1,74.1 c3,3,7.1,3,12.4,0.6L160.6,145.9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103950060853506590890000009027789913793620394_",
    gradientUnits: "userSpaceOnUse",
    x1: -227.151,
    y1: 468.5667,
    x2: -216.988,
    y2: 478.7296,
    gradientTransform: "matrix(5.9259 0 0 5.9259 1389.1111 -2772.9167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103950060853506590890000009027789913793620394_)"
    },
    d: "M160.6,96.2L74.1,47 c-5.3-3-9.5-2.4-12.4,0.6l74.1,73.5L160.6,96.2L160.6,96.2z"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M160,145.3l-85.9,48.6c-4.7,3-8.9,2.4-11.9,0l-0.6,0.6l0.6,0.6c3,2.4,7.1,3,11.9,0L160,145.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M61.6,193.9c-1.8-1.8-2.4-4.7-2.4-8.3v0.6c0,3.6,1.2,6.5,3,8.3v-0.6L61.6,193.9L61.6,193.9z M189.6,128.7 L160,145.3l0.6,0.6l29-16.6c4.1-2.4,5.9-5.3,5.9-8.3C195.6,124,193.2,126.4,189.6,128.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M74.1,47.6l115.6,65.8c3.6,2.4,5.9,4.7,5.9,7.7c0-3-1.8-5.9-5.9-8.3L74.1,47c-8.3-4.7-14.8-1.2-14.8,8.3v0.6 C59.3,47,65.8,42.8,74.1,47.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.bec0923982bac18a4094e103a52da116.svg";
export { ForwardRef as ReactComponent };